import {Button} from "primereact/button";
import {Toast} from "primereact/toast";
import {useRef} from "react";

import type {RevaLanguage} from "@reva/shared/i18n";

import {useRevaTranslation} from "../hooks/languageHooks";
import {updateUserProfileThunk} from "../redux/accountManagementThunk";
import {selectCredentials} from "../redux/authSlice";
import {useRevaDispatch, useRevaSelector} from "../redux/revaHooks";

function LanguageSwitcher() {
    const {t, i18n, language} = useRevaTranslation();
    const dispatch = useRevaDispatch();
    const toast = useRef<Toast>(null);

    // #19351: only logged-in users have a profile to sync the language to — e.g. the login screen
    // (Footer/LanguageSwitcher render there too) simply keeps the switch local.
    const credentials = useRevaSelector(selectCredentials);

    const nextLanguage: RevaLanguage = language === "de" ? "en" : "de";
    const label = language === "de" ? "DE" : "EN";

    const onClick = () => {
        // Switches immediately and locally, independent of whether the server sync below succeeds.
        void i18n.changeLanguage(nextLanguage);
        if (!credentials) return;
        dispatch(updateUserProfileThunk({language: nextLanguage})).catch(() => {
            toast.current?.show({
                severity: "warn",
                summary: t("language.localOnlyHintSummary"),
                detail: t("language.localOnlyHint"),
                life: 6000,
            });
        });
    };

    return (
        <>
            <Toast ref={toast} />
            <Button
                id="languageSwitcherButton"
                label={label}
                onClick={onClick}
                aria-label={t("language.switch")}
                text
                size="small"
            />
        </>
    );
}

export default LanguageSwitcher;
